export interface ResolutionPanelProps {
  exceptionId: number;
  onClose: () => void;
  onResolved: () => void;
}

export const ESCALATION_LEVELS: Record<string, { label: string; name: string; color: string; bg: string }> = {
  L1: { label: 'L1', name: 'AI Auto', color: '#059669', bg: '#f0fdf4' },
  L2: { label: 'L2', name: 'Analyst', color: '#0891b2', bg: '#ecfeff' },
  L3: { label: 'L3', name: 'Supervisor', color: '#b45309', bg: '#fffbeb' },
  L4: { label: 'L4', name: 'Manager', color: '#ea580c', bg: '#fff7ed' },
  L5: { label: 'L5', name: 'Director', color: '#dc2626', bg: '#fef2f2' },
  L6: { label: 'L6', name: 'CFO', color: 'var(--navy-800)', bg: '#f5f3ff' },
  L7: { label: 'L7', name: 'Board', color: '#1e3a5f', bg: '#e1ecf7' },
};

export const BUTTON_CONFIG: Record<string, { label: string; color: string; bg: string; border: string }> = {
  APPROVE:     { label: 'APPROVE & POST', color: 'var(--text-primary)', bg: 'rgba(0,212,170,0.15)', border: 'none' },
  ESCALATE:    { label: 'ESCALATE', color: 'var(--navy-800)', bg: '#f5f3ff', border: '1px solid #ddd6fe' },
  INVESTIGATE: { label: 'INVESTIGATE', color: 'var(--warning)', bg: 'rgba(251,191,36,0.12)', border: '1px solid #fde68a' },
  WRITE_OFF:   { label: 'WRITE OFF', color: 'var(--negative)', bg: 'rgba(248,113,113,0.12)', border: '1px solid #fecaca' },
  ACCRUE:      { label: 'ACCRUE', color: 'var(--navy-600)', bg: 'rgba(96,165,250,0.12)', border: '1px solid var(--accent-border)' },
};
